var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyGer5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.34741,
    width: 47,
    height: 47.8136,
    rx: 11.5,
    fill: "#F8FAFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.34741,
    width: 47,
    height: 47.8136,
    rx: 11.5,
    stroke: "#C4D8FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2851_4043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0242 33.5262V11.7565C12.0242 10.6899 12.8969 9.81714 13.9636 9.81714H30.7393C31.806 9.81714 32.6787 10.6899 32.6787 11.7565V35.9505",
    stroke: "#1A202C",
    strokeWidth: 0.969697,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7819 39.8777H14.1576C12.9455 39.8777 11.9758 38.908 11.9758 37.6959",
    stroke: "#1A202C",
    strokeWidth: 0.969697,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3334 19.0292H32.6304M37.3334 19.0292C38.2061 19.0292 38.8849 19.7564 38.8364 20.5807V36.7261C38.8364 38.4231 37.4304 39.8292 35.7334 39.8292C34.0364 39.8292 32.6304 38.4231 32.6304 36.7261V19.0292M37.3334 19.0292C36.4607 19.0292 35.7334 19.708 35.7334 20.5807V28.7746C35.7334 29.6474 35.0546 30.3261 34.1819 30.3261C33.3092 30.3261 32.6304 29.6474 32.6304 28.7746V19.0292",
    stroke: "#1A202C",
    strokeWidth: 0.969697,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0183 32.8959L15.8546 34.0111L13.5273 31.6838L14.6425 30.5201",
    stroke: "#1A202C",
    strokeWidth: 0.969697,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0061 33.1868C21.5767 33.1868 23.6607 31.1029 23.6607 28.5322C23.6607 25.9616 21.5767 23.8777 19.0061 23.8777C16.4355 23.8777 14.3516 25.9616 14.3516 28.5322C14.3516 31.1029 16.4355 33.1868 19.0061 33.1868Z",
    stroke: "#1A202C",
    strokeWidth: 0.969697,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9939 30.5686C19.8788 31.6838 18.0848 31.6838 16.9697 30.5686C15.8545 29.4535 15.8545 27.6595 16.9697 26.5444C18.0848 25.4292 19.8788 25.4292 20.9939 26.5444C22.1091 27.6595 22.1091 29.4535 20.9939 30.5686Z",
    stroke: "#1A202C",
    strokeWidth: 0.969697,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8302 37.8898L15.4181 33.6231L13.9636 32.1686L9.69691 35.7565C9.01813 36.3383 8.96964 37.3565 9.59994 38.0352C10.1818 38.6171 11.2484 38.5686 11.8302 37.8898Z",
    stroke: "#1A202C",
    strokeWidth: 0.969697,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6908 16.0716L18.812 12.4352C19.006 12.2413 19.3454 12.2413 19.5393 12.4352L23.6605 16.0716C24.0484 16.411 23.806 17.0413 23.2726 17.0413H15.0302C14.5454 17.0413 14.3514 16.411 14.6908 16.0716Z",
    stroke: "#1A202C",
    strokeWidth: 0.969697,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3515 21.8414H16.0969C15.6606 21.8414 15.2727 21.4535 15.2727 21.0171V17.0898H23.1757V21.0171C23.1757 21.4535 22.7879 21.8414 22.3515 21.8414Z",
    stroke: "#1A202C",
    strokeWidth: 0.969697,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9878 18.7869H20.4605V21.8414H17.9878V18.7869Z",
    stroke: "#1A202C",
    strokeWidth: 0.969697,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0667 25.2838H29.9636",
    stroke: "#1A202C",
    strokeWidth: 0.969697,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0364 28.2898H29.9636",
    stroke: "#1A202C",
    strokeWidth: 0.969697,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0364 31.3444H29.9636",
    stroke: "#1A202C",
    strokeWidth: 0.969697,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.085 15.0535H29.9637",
    stroke: "#1A202C",
    strokeWidth: 0.969697,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.491 17.5747H29.9637",
    stroke: "#1A202C",
    strokeWidth: 0.969697,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2788 20.0959H29.9637",
    stroke: "#1A202C",
    strokeWidth: 0.969697,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1272 34.3505H29.9636",
    stroke: "#1A202C",
    strokeWidth: 0.969697,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1455 37.3564H29.9637",
    stroke: "#1A202C",
    strokeWidth: 0.969697,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2851_4043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8.84741)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyGer5);
export default __webpack_public_path__ + "static/media/whyGer5.ea412a460ed80eb979b8064dc95dd22d.svg";
export { ForwardRef as ReactComponent };